import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BaseResponse } from '@app/types/BaseResponse'
import { TCurrentUserBody, TCurrentUserResponse } from '@app/types/TCurrentUser'
import { BaseHttpService } from '@core/services/base-http.service'
import { Observable } from 'rxjs'

@Injectable({
    providedIn: 'root',
})
export class ProfileApiService extends BaseHttpService {
    private apiUrl = '/api/Profile/'

    constructor(protected override http: HttpClient) {
        super(http)
    }

    getCurrentUser(): Observable<BaseResponse<TCurrentUserResponse>> {
        return this.get(this.apiUrl + `GetCurrentUser`)
    }

    updateCurrentUser(
        body: TCurrentUserBody
    ): Observable<BaseResponse<TCurrentUserResponse>> {
        return this.put(this.apiUrl + `UpdateProfile`, body)
    }
}
